module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Home","about":"About","contact":"Contact"},"tr":{"home":"Anasayfa","about":"Hakkımda","contact":"İletişim"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/view/global/app-navigation/index.vue
// module id = j1q5
// module chunks = 1